export type Theme = "dark" | "light";

const storageKey = "polyfuture.theme";
const themeColor: Record<Theme, string> = { dark: "#101211", light: "#f6f7f6" };

/** The theme this browser chose last. Dark when nothing is stored or storage is unavailable. */
export function readStoredTheme(): Theme {
  try {
    return window.localStorage.getItem(storageKey) === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
}

/** Remembers the choice for this browser only. A failed write still applies the theme. */
export function storeTheme(theme: Theme): void {
  try {
    window.localStorage.setItem(storageKey, theme);
  } catch {
    // Private windows and blocked site data refuse storage; the theme still applies this visit.
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset["theme"] = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", themeColor[theme]);
}
